module.exports = __webpack_public_path__ + "static/media/galerija_2017 (9).6d07ebc8.jpg";